import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {OfficeForAdmin} from 'types/api/offices/office'

export const useUpdateOffice = () => {
  const authAxios = useAuthAxios()
  return async (officeId: string, data: Omit<OfficeForAdmin, 'has_employees'>) =>
    authAxios.patch(`/api/offices/${officeId}`, data)
}
